/**
 * Implements a plain static table with a drilldown link handler.
 */

import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import Radio from "backbone.radio";
import DatatableLinkModel from "../../models/datatable-link";
import { decodeData } from "../../utils";

const channel = Radio.channel("global");

class View extends Backbone.View {
  render() {
    const table = new Table();
    const columns = this.model.get("meta").get("columns");

    const header = new TableHeader({
      model: columns,
    });

    const body = new TableBody({
      model: this.model.get("data"),
      columns: _.pluck(columns, "elementId"),
    });

    table.$el.append(header.el);
    table.$el.append(body.el);

    this.$el.append(table.el);

    return this;
  }
}

const Table = Backbone.View.extend({
  tagName: "table",
  className: "table table-striped table-bordered table-hover table-condensed",
  attributes: {
    width: "100%",
  },
});

const TableHeader = Backbone.View.extend({
  tagName: "thead",

  initialize() {
    this.render();
  },

  // compile an HTML template
  template: _.template(`
		<tr>
			<% _.each(columns, function(column) { %>
				<th><%= column.name %></th>
			<% }); %>
		</tr>
	`),

  render() {
    // generate markup by merging column data with template
    const markup = this.template({
      columns: this.model,
    });

    // append rendered html to container
    this.$el.html(markup);

    return this;
  },
});

const TableBody = Backbone.View.extend({
  tagName: "tbody",

  events: {
    "click a.drilldown": "onClick",
  },

  // compile an HTML template
  template: _.template(`
		<% _.each(data, function(row) { %>
			<tr>
				<% _.each(columns, function(column) { %>
					<td><%= row[column].value %></td>
				<% }); %>
			</tr>
		<% }) %>
	`),

  initialize(options) {
    this.columns = options.columns;

    this.render();
  },

  render() {
    // generate markup by merging column data with template
    const markup = this.template({
      data: this.model,
      columns: this.columns,
    });

    // append rendered html to container
    this.$el.html(markup);

    return this;
  },

  onClick(e) {
    e.preventDefault();

    // extract link data
    const linkData = $(e.currentTarget).data();
    const { type, url, params } = linkData;

    const data = JSON.parse(decodeData(params));
    const endpoint = decodeData(url);

    const linkModel = new DatatableLinkModel({
      type,
      endpoint,
      data,
    });

    channel.trigger("launch-link", linkModel);
  },
});

export { View as default };
